
import React, { Component } from "react";
// reactstrap components
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  Media,
  UncontrolledTooltip,
  Row
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";

// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// connect
import connect from 'redux-connect-decorator';
import { getWords } from '../../../../actions/glossaryActions';
import { limitContent } from '../../../../utils/ccl-utils';
import { getUserInfo } from '../../../../actions/authActions';
import VoicePlayer from '../../components/VoicePlayer';

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={e => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  )
});

const { SearchBar } = Search;

const allUpperCase = (cell, row) => {
  return <span>{cell.toUpperCase()}</span>;
}

const allBold = (cell, row) => {
  return <b>{cell}</b>;
}

const allItalic = (cell, row) => {
  return <i>{cell}</i>;
}

const formatTopic = (cell, row) => {
  return <Media className="align-items-center">
      <a className="topic mr-3" onClick={e => e.preventDefault()}>
        <div className={`bg-topic bg-topic-default bg-topic-${cell.toUpperCase()}`}></div>
      </a>
      <Media>
        <span className="name mb-0 text-sm">
          { cell.toUpperCase() }
        </span>
      </Media>
    </Media>;
}

@connect(
  state => ({
    words: state.word.words,
    loading: state.word.loading
  }),
  {
    getWords,
    getUserInfo
  }
)
class AllTopic extends Component<any, any> {
  voicePlayerRef;

  componentDidMount() {
    this.props.getWords();
    this.props.getUserInfo();
  }

  constructor(props) {
    super(props);
    this.state = {
      random: 0,
      english: null,
      vietnamese: null,
      usage: null,
      pronunciation: null,
      topic: null,
      filtered: [],
      filterAll: ''
    };

    this.voicePlayerRef = React.createRef();
  }

  speak = (e, row) => {
    e.preventDefault();
    // reset
    this.voicePlayerRef.current.onSpeak(row.english);
  }

  addActionButton = (cell, row) => {
    return (
        <div className="table-actions">
            <a
              className="table-action table-action-transcript"
              href="#"
              id="tooltip123539273"
              onClick={e => this.speak(e, row)}
            >
              <i className="fas fa-volume-up" />
            </a>
        </div>
    )
  }

  render() {
    const { words, loading } = this.props;
    return (
      <>
        <SimpleHeader name="All Topic" parentName="Glossary" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
                <Card>
                  <CardBody>
                    <div className="pt-1 text-center">
                      <h3>{this.state.topic}</h3>
                      <h5>{this.state.english} { this.state.english && <VoicePlayer text={ this.state.english } />}</h5>
                      <h5>{this.state.vietnamese}</h5>
                      <div>
                        <small>{this.state.pronunciation}</small>
                      </div>
                      { this.state.usage && <div>
                        <blockquote>{this.state.usage}</blockquote>
                      </div>}
                    </div>
                    <div className="pt-1 text-center">
                      <Button className="btn btn-info"
                          disabled={ loading } 
                          onClick={() => {
                            this.setState({
                              random: Math.floor(Math.random()*words.length),
                              english: words[this.state.random].english,
                              vietnamese: words[this.state.random].vietnamese,
                              usage: words[this.state.random].usage,
                              pronunciation: words[this.state.random].pronunciation,
                              topic: words[this.state.random].topic
                            });
                          }}
                        >
                          New Word
                      </Button>
                    </div>
                  </CardBody>
                </Card>
            </div>
          </Row>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">CCL En-Vn Dictionary</h3>
                  <p className="text-sm mb-0">All Vocabulary</p>
                </CardHeader>
                <ToolkitProvider
                  data={ words }
                  keyField="english"
                  columns={[
                    {
                      dataField: "topic",
                      text: "Topic",
                      sort: true,
                      formatter: formatTopic
                    },
                    {
                      dataField: "english",
                      text: "English",
                      sort: true,
                      formatter: allBold
                    },
                    {
                      dataField: "vietnamese",
                      text: "Vietnamese",
                      formatter: allItalic,
                      sort: true
                    },
                    {
                      dataField: "pronunciation",
                      text: "Pronunciation",
                      sort: false
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      searchable: false,
                      sort: false,
                      formatter: this.addActionButton
                    }
                  ]}
                  search
                >
                  {props => (
                    <div className="py-4 table-responsive align-items-center table-flush table">
                      <div
                        id="datatable-basic_filter"
                        className="dataTables_filter px-4 pb-1"
                      >
                        <label>
                          Search:
                          <SearchBar
                            className="form-control-sm"
                            placeholder=""
                            {...props.searchProps}
                          />
                        </label>
                      </div>
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        pagination={pagination}
                        bordered={false}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Card>
            </div>
          </Row>
          <div style={{ display: 'none'}}>
            <VoicePlayer ref={this.voicePlayerRef} text="" />
          </div>
        </Container>
      </>
    );
  }
}

export default AllTopic;
